import { useQuery } from "react-query";
import http from "shared/http";

export interface ResourceCategory {
  id: number;
  name: string;
  parentName?: string;
}

export interface ResourceRole {
  id: number;
  name: string;
}

export interface ResourceDetail {
  id: number;
  title: string;
  summary: string | null;
  resourceType: string; // "REPORT" | "LINK" | "FILE"
  // Report-specific
  workspaceId?: string | null;
  reportId?: string | null;
  datasetId?: string | null;
  requiresEffectiveIdentity?: boolean;
  defaultPageName?: string | null;
  pbiRoles?: string | null;
  agencyCodes?: string[];
  // Link-specific
  url?: string | null;
  mode?: string | null;
  // File-specific
  storageProvider?: string | null;
  fileName?: string | null;
  mimeType?: string | null;
  downloadURL?: string | null;
}

export const useGetResourceDetailQuery = (resourceId: number) =>
  useQuery(
    ["resource-detail", resourceId],
    async (): Promise<ResourceDetail> =>
      http.fetchAsync(`resource/${resourceId}`),
    { enabled: resourceId > 0, staleTime: 5 * 60 * 1000 },
  );

export const useGetCategoriesForResource = (resourceId: number) => {
  return useQuery(
    ["resource-categories", resourceId],
    async (): Promise<{
      available: ResourceCategory[];
      assigned: ResourceCategory[];
    }> => {
      return await http.fetchAsync(`admin/resources/${resourceId}/categories`);
    },
    {
      //staleTime: 30 * 1000,
    },
  );
};

export const useGetRolesForResource = (resourceId: number) => {
  return useQuery(
    ["resource-roles", resourceId],
    async (): Promise<{
      available: ResourceRole[];
      assigned: ResourceRole[];
    }> => {
      return await http.fetchAsync(`admin/resources/${resourceId}/roles`);
    },
    {
      //staleTime: 30 * 1000,
    },
  );
};
